/*
 * Thrown when a prepared file/body is deterministically empty.
 * These failures are permanent and must not be retried.
 */
class EmptyUploadError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'EmptyUploadError';
    }
}

// ----------------------------------------------------------------------------

export { EmptyUploadError };
